<template>
    <div class="searchBox">
        <div class="searchItem">
            <div class="searchLabel">日志类型：</div>
            
            <a-select show-search :value="selectType" placeholder="选择日志类型"  allow-clear style="width: 150px"
                @change="handleChange">
                <a-select-option v-for="d in logTypes"  :key="d.value">
                    {{ d.label }}
                </a-select-option>
            </a-select>

           <a-input v-if="selectType  == ''" style="width:150px;margin-left:20px;" placeholder="输入自定义logType" v-model="searchP.logType" />

        </div>


        <div class="ItemGroup">
            <div class="searchItem">
                <div class="searchLabel">sessionID：</div>
                <a-input style="width:200px;" placeholder="用户访问周期的id" v-model="searchP.session_id" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">设备编号：</div>
                <a-input style="width:200px;" placeholder="设备编号" v-model="searchP.device_id" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">用户身份：</div>
                <a-input style="width:200px;" placeholder="输入用户身份关键字" v-model="searchP.user_sign" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">页面路由：</div>
                <a-input style="width:200px;" placeholder="输入路由关键字" v-model="searchP.url_path" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">页面标题：</div>
                <a-input style="width:200px;" placeholder="输入页面标题关键字" v-model="searchP.url_title" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">前向地址：</div>
                <a-input style="width:200px;" placeholder="输入页面前向地址关键字" v-model="searchP.referrer" />
            </div>


            <div class="searchItem">
                <div class="searchLabel">浏览器：</div>
                <a-select mode="default" v-model="searchP.browser" style="width: 100px;" placeholder="请选择浏览器"
                    show-search>
                    <a-select-option v-for="item in browserlist" :key="item">
                        {{ item ? item : '全部' }}
                    </a-select-option>
                </a-select>
            </div>

            <div class="searchItem">
                <div class="searchLabel">系统：</div>
                <a-select mode="default" v-model="searchP.os" style="width: 100px;" placeholder="请选择浏览器" show-search>
                    <a-select-option v-for="item in osList" :key="item">
                        {{ item ? item : '全部' }}
                    </a-select-option>
                </a-select>
            </div>

            <div class="searchItem">
                <div class="searchLabel">软件版本：</div>
                <a-input style="width:200px;" placeholder="软件版本号" v-model="searchP.app_version" />
            </div>
        </div>

        <!-- 页面加载 -->
        <div class="ItemGroup" v-if="searchP.logType == 'pv' || selectType == ''">
            <div class="searchItem">
                <div class="searchLabel">首次访问：</div>
                <a-radio-group v-model="searchP.isFirst">
                    <a-radio :value="1">
                        全部
                    </a-radio>
                    <a-radio :value="2">
                        是
                    </a-radio>
                    <a-radio :value="3">
                        否
                    </a-radio>
                </a-radio-group>
            </div>
            <div class="searchItem">
                <div class="searchLabel">首屏加载：</div>
                <a-radio-group v-model="searchP.isLoad">
                    <a-radio :value="1">
                        全部
                    </a-radio>
                    <a-radio :value="2">
                        首屏
                    </a-radio>
                    <a-radio :value="3">
                        路由
                    </a-radio>
                </a-radio-group>
            </div>
            
        </div>

        <!-- 点击事件 -->
        <div class="ItemGroup"  v-if="searchP.logType == 'click' || selectType == ''">
            <div class="searchItem">
                <div class="searchLabel">元素id：</div>
                <a-input style="width:200px;" placeholder="元素id关键字" v-model="searchP.ck_el_id" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">元素html：</div>
                <a-input style="width:200px;" placeholder="元素innerhtml关键字" v-model="searchP.ck_el_html" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">trackid：</div>
                <a-input style="width:200px;" placeholder="业务埋点id" v-model="searchP.ck_el_trackid" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">元素内容：</div>
                <a-input style="width:200px;" placeholder="点击元素内容关键字" v-model="searchP.ck_el_content" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">元素类型：</div>
                <a-input style="width:200px;" placeholder="点击元素类型关键字" v-model="searchP.ck_el_type" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">元素地址：</div>
                <a-input style="width:200px;" placeholder="a 标签链接地址关键字" v-model="searchP.ck_el_href" />
            </div>
            
        </div>

        <!-- 资源加载 -->
        <div class="ItemGroup"  v-if="searchP.logType == 'resource' || selectType == ''">
            <div class="searchItem">
                <div class="searchLabel">资源地址：</div>
                <a-input style="width:200px;" placeholder="资源地址关键字" v-model="searchP.res_url" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">资源类型：</div>

                <a-select mode="default" v-model="searchP.res_type" style="width: 100px;" placeholder="请选资源类型"
                    show-search>
                    <a-select-option v-for="item in res_type_list" :key="item">
                        {{ item ? item : '全部' }}
                    </a-select-option>
                </a-select>
            </div>
            
        </div>

        <!-- 接口请求 -->
        <div class="ItemGroup"  v-if="searchP.logType == 'api' || selectType == ''">
            <div class="searchItem">
                <div class="searchLabel">接口地址：</div>
                <a-input style="width:200px;" placeholder="接口地址关键字" v-model="searchP.res_url" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">链路id：</div>
                <a-input style="width:200px;" placeholder="后端请求链路traceid" v-model="searchP.res_traceid" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">状态编码：</div>
                <a-input style="width:200px;" placeholder="请求状态编码" v-model="searchP.res_statues" />
            </div>
            
        </div>

        <!-- 脚本异常 -->
        <div class="ItemGroup"  v-if="searchP.logType == 'js-error' || selectType == ''">
            <div class="searchItem">
                <div class="searchLabel">错误类型：</div>
                <a-input style="width:200px;" placeholder="错误类型关键字" v-model="searchP.js_err_name" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">错误消息：</div>
                <a-input style="width:200px;" placeholder="错误消息关键字" v-model="searchP.js_err_msg" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">错误堆栈：</div>
                <a-input style="width:200px;" placeholder="错误堆栈关键字" v-model="searchP.js_err_stack" />
            </div>
            
        </div>

        <!-- 设备信息-->
        <div class="ItemGroup"  v-if="searchP.logType == 'pos-callback' || selectType == ''">
            <div class="searchItem">
                <div class="searchLabel">设备型号：</div>
                <a-input style="width:200px;" placeholder="设备型号关键字" v-model="searchP.pos_device_model" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">系统版本：</div>
                <a-input style="width:200px;" placeholder="系统版本号关键字" v-model="searchP.pos_device_sys_version" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">网络类型：</div>
                <a-input style="width:200px;" placeholder="网络类型关键字" v-model="searchP.pos_device_network_type" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">软件版本：</div>
                <a-input style="width:200px;" placeholder="软件版本号关键字" v-model="searchP.pos_device_software_version" />
            </div>
        </div>

        <!-- 终端告警 -->
        <div class="ItemGroup"  v-if="searchP.logType == 'pos-warn' || selectType == ''">
            <div class="searchItem">
                <div class="searchLabel">告警类名：</div>
                <a-input style="width:200px;" placeholder="告警类名关键字" v-model="searchP.pos_warn_class" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">告警名：</div>
                <a-input style="width:200px;" placeholder="告警名关键字" v-model="searchP.pos_warn_name" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">告警进程：</div>
                <a-input style="width:200px;" placeholder="告警进程或堆栈关键字" v-model="searchP.pos_warn_thread" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">告警信息：</div>
                <a-input style="width:200px;" placeholder="告警信息关键字" v-model="searchP.pos_warn_msg" />
            </div>
            
        </div>

        <!-- 业务埋点 -->
        <div class="ItemGroup"  v-if="searchP.logType == 'business-point' || selectType == ''">
            

            <div class="searchItem">
                <div class="searchLabel">eventcode：</div>
                <a-input style="width:200px;" placeholder="事件编码" v-model="searchP.eventcode" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">eventname：</div>
                <a-input style="width:200px;" placeholder="事件名称" v-model="searchP.eventname" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">action:</div>
                <a-input style="width:200px;" placeholder="action" v-model="searchP.action" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">business：</div>
                <a-input style="width:200px;" placeholder="business" v-model="searchP.business" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">businesscode:</div>
                <a-input style="width:200px;" placeholder="businesscode" v-model="searchP.businesscode" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">shopcode：</div>
                <a-input style="width:200px;" placeholder="商户编码" v-model="searchP.shopcode" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">shopname：</div>
                <a-input style="width:200px;" placeholder="shopname" v-model="searchP.shopname" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">branchcode：</div>
                <a-input style="width:200px;" placeholder="门店编码" v-model="searchP.branchcode" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">branchname：</div>
                <a-input style="width:200px;" placeholder="branchname" v-model="searchP.branchname" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">usercode：</div>
                <a-input style="width:200px;" placeholder="usercode" v-model="searchP.usercode" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">openid：</div>
                <a-input style="width:200px;" placeholder="openid" v-model="searchP.openid" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">unionid：</div>
                <a-input style="width:200px;" placeholder="unionid" v-model="searchP.unionid" />
            </div>
            
            <div class="searchItem">
                <div class="searchLabel">deviceid：</div>
                <a-input style="width:200px;" placeholder="设备id" v-model="searchP.deviceid" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">starttime：</div>
                <a-input style="width:200px;" placeholder="starttime" v-model="searchP.starttime" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">endtime：</div>
                <a-input style="width:200px;" placeholder="endtime" v-model="searchP.endtime" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">pagename：</div>
                <a-input style="width:200px;" placeholder="pagename" v-model="searchP.pagename" />
            </div>

            <div class="searchItem">
                <div class="searchLabel">attributes：</div>
                <a-input style="width:200px;" placeholder="其他属性" v-model="searchP.attributes" />
            </div>
        </div>


        <a-button class="searchItem" style="margin-right:20px" @click="handleReset">重置</a-button>

        <a-button type="primary" @click="handleSubmit">
            查询
        </a-button>

    </div>
</template>

<script>

const logTypes = [
    {
        label:'自定义',
        value:''
    },
    {
        label:'页面浏览',
        value:'pv'
    },
    {
        label:'页面点击',
        value:'click'
    },
    {
        label:'资源加载',
        value:'resource'
    },
    {
        label:'接口请求',
        value:'api'
    },
    {
        label:'脚本异常',
        value:'js-error'
    },
    {
        label:'硬件信息',
        value:'pos-callback'
    },
    {
        label:'终端告警',
        value:'pos-warn'
    },
    {
        label:'业务埋点',
        value:'business-point'
    },

]


const browserlist = [
    '',
    'chrome',
    'edge',
    'ie11',
    'ie',
    'firefox',
    'safari',
    'sgssapp',
    'wechat',
    'weibo',
    'uc',
    'sogou',
    'xiaomi',
    'baidu',
    '360',
    '2345',
    'qqbrowser',
    'qq',
    'opera',
    'other'
]

const osList = [
    '',
    'windows',
    'macOS',
    'ios',
    'android',
    'other'
]

const res_type_list = [
    '',
    'link',
    'img',
    'iframe',
    'css',
    'xmlhttprequest',
    'fetch',
    'navigation',
    'other',
]

const default_searchp = {
    session_id:'',
    device_id:'',
    logType:'pv',
    user_sign:'',
    urlPath:'',
    url_title:'',
    referrer:'',
    browser:'',
    os:'',
    app_version:'',
    //pv
    isFirst:1,
    isLoad:1,
    //点击事件部分
    ck_el_id:'',
    ck_el_html:'',
    ck_el_trackid:'',
    ck_el_content:'',
    ck_el_type:'',
    ck_el_href:'',
    //资源 api
    res_url:'',
    res_traceid:'',
    res_statues:'',
    res_type:'',
    //js-error
    js_err_name:'',
    js_err_msg:'',
    js_err_stack:'',
    //pos-callback
    pos_device_model:'',
    pos_device_sys_version:'',
    pos_device_network_type:'',
    pos_device_software_version:'',
    //pos-warn
    pos_warn_class:'',
    pos_warn_name:'',
    pos_warn_thread:'',
    pos_warn_msg:'',

    //business-point
    eventcode:'',
    eventname:'',
    action:'',
    business:'',
    businesscode:'',
    shopcode:'',
    shopname:'',
    branchcode:'',
    branchname:'',
    usercode:'',
    openid:'',
    unionid:'',
    deviceid:'',
    starttime:'',
    endtime:'',
    pagename:'',
    attributes:'',
}

export default {
    data() {
        return {
            browserlist,
            logTypes,
            selectType:'pv',
            osList,
            res_type_list,
            searchP:default_searchp
        };
    },
    methods: {
        handleChange(v){
            this.selectType = v;
            if(v != ''){
                this.searchP.logType = v
                this.handleSubmit()

            }
        },

        handleSubmit() {
            localStorage.setItem('monitorweb_logs_searchp',JSON.stringify(this.searchP))
            this.$emit('handleSearchChange',this.searchP);
        },
        //重置按钮
        handleReset(){
            localStorage.setItem('monitorweb_logs_searchp','');
            this.$router.push({
                path: '/monitorweb/logs',
                query:{
                    _rmd:this.G.RndNum(5),
                }
            })
        },
    },
    mounted(){
        let cachedSearchP = localStorage.getItem('monitorweb_logs_searchp');
        if(cachedSearchP){
            this.searchP = JSON.parse(cachedSearchP)
        }
        //路由传日志类型
        const {query} = this.$route;
        if(query.logType){
            this.searchP.logType = query.logType
        }
        if(query.pos_warn_name){
            this.searchP.pos_warn_name = query.pos_warn_name
        }

        if(query.js_err_msg){
            this.searchP.js_err_msg = query.js_err_msg
        }
        //监控告警
        if(query.qt){
            this.searchP = default_searchp;
            switch (query.qt) {
                case "1":
                    //【老版收银机】接口前端超时告警
                    this.searchP.logType = 'api';
                    this.searchP.res_statues = 'timeout';
                    break;
                case "2":
                    //【老版收银机】JS控制台异常告警
                    this.searchP.logType = 'js-error';
                    break;
                case "3":
                    //【老版收银机】支付接口前端超时告警
                    this.searchP.logType = 'api';
                    this.searchP.res_statues = 'timeout';
                    this.searchP.res_url = 'pay'
                    break;
                case "4":
                    //【老版收银机】登陆接口前端超时告警
                    this.searchP.logType = 'api';
                    this.searchP.res_statues = 'timeout';
                    this.searchP.res_url = 'zl.pos.login.loginuser'
                    break;
                case "5":
                    //【老版收银机】前端接口解析异常监控
                    this.searchP.logType = 'api';
                    this.searchP.res_statues = 'requestError';
                    break;
                case "6":
                    //【银响力V5】接口超时告警
                    this.searchP.logType = 'api';
                    this.searchP.res_statues = 'timeout';
                    break;
                case "7":
                    //【银响力V5】JS控制台异常告警
                    this.searchP.logType = 'js-error';
                    break;
                
                    
                default:
                    break;
            }
        }
        
        this.handleSubmit();
    }
};
</script>

<style lang="less" scoped>
    .searchBox{
        margin: 20px 0;
    }
    .searchLabel{
        width:80px;
        display: inline-block;
        color:rgba(0,0,0,.85);
    }
    .searchItem{
        margin-bottom: 20px;
    }

    .ItemGroup{
        width:100%;
        height:auto;
        display: inline-block;
    }

    .ItemGroup .searchItem{
        float: left;
        margin-right:20px;
    }
</style>